import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import userSlice from '../features/user/userSlice';
import placesSlice from '../features/places/placesSlice';
import messagesSlice from '../features/messages/messagesSlice';
import staffSlice from '../features/staff/staffSlice';

export const store = configureStore({
  reducer: {
    user: userSlice,
    places: placesSlice,
    messages: messagesSlice,
    staff: staffSlice
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
